__turbopack_context__.v({
  "backdrop": "mobile-navigation-module-scss-module__HUF3WW__backdrop",
  "drawer": "mobile-navigation-module-scss-module__HUF3WW__drawer",
  "drawerClosed": "mobile-navigation-module-scss-module__HUF3WW__drawerClosed",
  "drawerInner": "mobile-navigation-module-scss-module__HUF3WW__drawerInner",
  "drawerOpen": "mobile-navigation-module-scss-module__HUF3WW__drawerOpen",
  "header": "mobile-navigation-module-scss-module__HUF3WW__header",
  "headerStart": "mobile-navigation-module-scss-module__HUF3WW__headerStart",
  "logoImage": "mobile-navigation-module-scss-module__HUF3WW__logoImage",
  "logoRow": "mobile-navigation-module-scss-module__HUF3WW__logoRow",
  "logoWrap": "mobile-navigation-module-scss-module__HUF3WW__logoWrap",
  "menuButton": "mobile-navigation-module-scss-module__HUF3WW__menuButton",
  "menuIcon": "mobile-navigation-module-scss-module__HUF3WW__menuIcon",
  "navScroll": "mobile-navigation-module-scss-module__HUF3WW__navScroll",
  "overlay": "mobile-navigation-module-scss-module__HUF3WW__overlay",
  "overlayClosed": "mobile-navigation-module-scss-module__HUF3WW__overlayClosed",
  "overlayOpen": "mobile-navigation-module-scss-module__HUF3WW__overlayOpen",
  "pageTitle": "mobile-navigation-module-scss-module__HUF3WW__pageTitle",
  "userFooter": "mobile-navigation-module-scss-module__HUF3WW__userFooter",
});
